import { render, staticRenderFns } from "./WorkRightsStep.vue?vue&type=template&id=b4d08c36"
import script from "./WorkRightsStep.vue?vue&type=script&lang=js"
export * from "./WorkRightsStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports